export const languages = [
    {id: 0, label: 'Abkhazian'},
    {id: 1, label: 'Afar'},
    {id: 2, label: 'Afrikaans'},
    {id: 3, label: 'Albanian'},
    {id: 4, label: 'Amharic'},
    {id: 5, label: 'Arabic'},
    {id: 6, label: 'Aragonese'},
    {id: 7, label: 'Armenian'},
    {id: 8, label: 'Assamese'},
    {id: 9, label: 'Avar'},
    {id: 10, label: 'Aymara'},
    {id: 11, label: 'Azerbaijani'},
    {id: 12, label: 'Bashkir'},
    {id: 13, label: 'Basque'},
    {id: 14, label: 'Belarusian'},
    {id: 15, label: 'Bengali'},
    {id: 16, label: 'Bihari'},
    {id: 17, label: 'Bislama'},
    {id: 18, label: 'Bosnian'},
    {id: 19, label: 'Breton'},
    {id: 20, label: 'Bulgarian'},
    {id: 21, label: 'Burmese'},
    {id: 22, label: 'Catalan'},
    {id: 23, label: 'Chamorro'},
    {id: 24, label: 'Chechen'},
    {id: 25, label: 'Chinese'},
    {id: 26, label: 'Chuvash'},
    {id: 27, label: 'Cornish'},
    {id: 28, label: 'Corsican'},
    {id: 29, label: 'Croatian'},
    {id: 30, label: 'Czech'},
    {id: 31, label: 'Danish'},
    {id: 32, label: 'Maldivian'},
    {id: 33, label: 'Dutch'},
    {id: 34, label: 'Dzongkha'},
    {id: 35, label: 'English'},
    {id: 36, label: 'Esperanto'},
    {id: 37, label: 'Estonian'},
    {id: 38, label: 'Faroese'},
    {id: 39, label: 'Fijian'},
    {id: 40, label: 'Finnish'},
    {id: 41, label: 'French'},
    {id: 42, label: 'Scottish Gaelic'},
    {id: 43, label: 'Galician'},
    {id: 44, label: 'Georgian'},
    {id: 45, label: 'German'},
    {id: 46, label: 'Greek'},
    {id: 47, label: "Guarani"},
    {id: 48, label: 'Gujarati'},
    {id: 49, label: 'Haitian'},
    {id: 50, label: 'Hausa'},
    {id: 51, label: 'Hebrew'},
    {id: 52, label: 'Herero'},
    {id: 53, label: 'Hindi'},
    {id: 54, label: 'Hiri Motu'},
    {id: 55, label: 'Hungarian'},
    {id: 56, label: 'Icelandic'},
    {id: 57, label: 'Ido'},
    {id: 58, label: 'Indonesian'},
    {id: 59, label: 'Interlingua'},
    {id: 60, label: 'Interlingue'},
    {id: 61, label: 'Inuktitut'},
    {id: 62, label: 'Inupiaq'},
    {id: 63, label: 'Irish'},
    {id: 64, label: 'Italian'},
    {id: 65, label: 'Japanese'},
    {id: 66, label: 'Javanese'},
    {id: 67, label: 'Greenlandic'},
    {id: 68, label: 'Kannada'},
    {id: 69, label: 'Kashmiri'},
    {id: 70, label: 'Kazakh'},
    {id: 71, label: 'Cambodian'},
    {id: 72, label: 'Kikuyu'},
    {id: 73, label: 'Rwandi'},
    {id: 74, label: 'Kirghiz'},
    {id: 75, label: 'Komi'},
    {id: 76, label: 'Korean'},
    {id: 77, label: 'Kuanyama'},
    {id: 78, label: 'Kurdish'},
    {id: 79, label: 'Laotian'},
    {id: 80, label: 'Latin'},
    {id: 81, label: 'Latvian'},
    {id: 82, label: 'Limburgian'},
    {id: 83, label: 'Lingala'},
    {id: 84, label: 'Lithuanian'},
    {id: 85, label: 'Luxembourgish'},
    {id: 86, label: 'Macedonian'},
    {id: 87, label: 'Malagasy'},
    {id: 88, label: 'Malay'},
    {id: 89, label: 'Malayalam'},
    {id: 90, label: 'Maltese'},
    {id: 91, label: 'Manx'},
    {id: 92, label: 'Māori'},
    {id: 93, label: 'Marathi'},
    {id: 94, label: 'Marshallese'},
    {id: 95, label: 'Moldovan'},
    {id: 96, label: 'Mongolian'},
    {id: 97, label: 'Nauruan'},
    {id: 98, label: 'Navaho'},
    {id: 99, label: 'North Ndebele'},
    {id: 100, label: 'South Ndebele'},
    {id: 101, label: 'Ndonga'},
    {id: 102, label: 'Nepali'},
    {id: 103, label: 'Northern Sami'},
    {id: 104, label: 'Norwegian Bokmål'},
    {id: 105, label: 'Norwegian'},
    {id: 106, label: 'Norwegian Nynorsk'},
    {id: 107, label: 'Nyanja'},
    {id: 108, label: 'Occitan'},
    {id: 109, label: 'Oriya'},
    {id: 110, label: 'Oromo'},
    {id: 111, label: 'Ossetian / Ossetic'},
    {id: 112, label: 'Pali'},
    {id: 113, label: 'Panjabi / Punjabi'},
    {id: 114, label: 'Persian'},
    {id: 115, label: 'Polish'},
    {id: 116, label: 'Portuguese'},
    {id: 117, label: 'Pushto'},
    {id: 118, label: 'Quechua'},
    {id: 119, label: 'Raeto Romance'},
    {id: 120, label: 'Romanian'},
    {id: 121, label: 'Kirundi'},
    {id: 122, label: 'Russian'},
    {id: 123, label: 'Samoan'},
    {id: 124, label: 'Sango'},
    {id: 125, label: 'Sanskrit'},
    {id: 126, label: 'Sardinian'},
    {id: 127, label: 'Српски'},
    {id: 128, label: 'Shona'},
    {id: 129, label: 'Sichuan Yi'},
    {id: 130, label: 'सिनधि'},
    {id: 131, label: 'Sinhala'},
    {id: 132, label: 'Slovak'},
    {id: 133, label: 'Slovenian'},
    {id: 134, label: 'Somalia'},
    {id: 135, label: 'Southern Sotho'},
    {id: 136, label: 'Spanish'},
    {id: 137, label: 'Sundanese'},
    {id: 138, label: 'Swahili'},
    {id: 139, label: 'Swati'},
    {id: 140, label: 'Swedish'},
    {id: 141, label: 'Tagalog'},
    {id: 142, label: 'Tahitian'},
    {id: 143, label: 'Tajik'},
    {id: 144, label: 'Tamil'},
    {id: 145, label: 'Tatar'},
    {id: 146, label: 'Telugu'},
    {id: 147, label: 'Thai'},
    {id: 148, label: 'Tibetan'},
    {id: 149, label: 'Tigrinya'},
    {id: 150, label: 'Tonga'},
    {id: 151, label: 'Tsonga'},
    {id: 152, label: 'Tswana'},
    {id: 153, label: 'Turkish'},
    {id: 154, label: 'Turkmen'},
    {id: 155, label: 'Twi'},
    {id: 156, label: 'Uighur'},
    {id: 157, label: 'Ukrainian'},
    {id: 158, label: 'Urdu'},
    {id: 159, label: 'Uzbek'},
    {id: 160, label: 'Vietnamese'},
    {id: 161, label: 'Volapük'},
    {id: 162, label: 'Walloon'},
    {id: 163, label: 'Welsh'},
    {id: 164, label: 'West Frisian'},
    {id: 165, label: 'Wolof'},
    {id: 166, label: 'Xhosa'},
    {id: 167, label: 'Yiddish'},
    {id: 168, label: 'Yoruba'},
    {id: 169, label: 'Zhuang'},
    {id: 170, label: 'Zulu'}
];
